export interface FileDetails {
  id: string;
  name: string;
  author: string;
  type: FileType;
  size: number;
  contentType: string;
  parent: FileDetails;
  createdAt: Date;
  allowedFileFormats: string;
}

export enum FileType {
  FILE = 'FILE',
  FOLDER = 'FOLDER'
}
